import { render } from "./HelpDialog.vue?vue&type=template&id=69a2b606&scoped=true&ts=true"
import script from "./HelpDialog.vue?vue&type=script&lang=ts"
export * from "./HelpDialog.vue?vue&type=script&lang=ts"

import "./HelpDialog.vue?vue&type=style&index=0&id=69a2b606&scoped=true&lang=css"

import exportComponent from "C:\\Users\\breno\\Documents\\Workspace\\Coll\\palavra-quadrada\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69a2b606"]])

export default __exports__